import Loadable from '../../../../components/loadable';

export default Loadable(() =>
  import(/* webpackChunkName: "beauty-tech-forum-virtual-detail" */ './index')
);
